/***************************************************
 * Created by gongyanyu on 2023/3/29 09:56. *
 ***************************************************/ import { extendObservable, isObservableProp, observable, runInAction, set, isComputedProp } from "mobx";
import { isRefCreator } from "./initDataRef";
import { isPlainObject } from "./isPlainObject";
import { mapReduce } from "./mapReduce";
function isCanSerialized(obj) {
    try {
        JSON.stringify(obj);
        return true;
    } catch (e) {
        return false;
    }
}
function getObservableFactory(value) {
    if (value === null || value === undefined) return observable;
    if (isRefCreator(value)) return false;
    if (Array.isArray(value) && isCanSerialized(value)) return observable;
    if (Array.isArray(value) && !isCanSerialized(value)) return observable.shallow;
    if (!isPlainObject(value)) return observable.ref;
    if (isPlainObject(value) && !isCanSerialized(value)) return observable.shallow;
    return observable;
}
export function initExtends(target, properties, keys) {
    if (target === undefined || target === null || properties === undefined || properties === null) return;
    if (!isPlainObject(properties)) {
        console.error("ERROR: $register 被一个非普通对象调用, 请修正. ", properties);
        return;
    }
    keys = keys !== null && keys !== void 0 ? keys : Object.keys(properties);
    if (!keys || !keys.length) return;
    var existentKeys = keys.filter(function(key) {
        return isObservableProp(target, key) && !isComputedProp(target, key);
    });
    var computedKeys = keys.filter(function(key) {
        return isComputedProp(target, key);
    });
    var nonexistentKeys = keys.filter(function(key) {
        return !~existentKeys.indexOf(key) && !~computedKeys.indexOf(key);
    });
    runInAction(function() {
        if (existentKeys.length) {
            set(target, mapReduce(existentKeys, function(key) {
                return properties[key];
            }));
        }
        if (computedKeys.length) {
            set(target, mapReduce(computedKeys, function(key) {
                return properties[key];
            }));
        }
    });
    if (nonexistentKeys.length) {
        var annotations = {};
        var props = nonexistentKeys.reduce(function(oo, key) {
            var value = properties[key];
            annotations[key] = getObservableFactory(value);
            if (isRefCreator(value)) value(oo, key);
            else oo[key] = value;
            return oo;
        }, {});
        extendObservable(target, props, annotations);
    }
}
